/*
* Sorts an array of distribution lines by line_number value
* @param {Array} lines
* @return Array
*/
export default function (lines) {
  if (lines && lines.length) {
    const allLinesHaveNumbers = lines.every(v => {
      if (v) {
        return (v.hasOwnProperty('line_number') && parseInt(v.line_number) >= 0)
      }
      return false
    })
    if (allLinesHaveNumbers) {
      lines = lines.sort((a, b) => a.line_number - b.line_number)
    }
  }
  return lines
}



// WEBPACK FOOTER //
// ./src/utils/helpers/DataEntryViews/SortLines.js